export default {
  'nav.home': 'Home',
  'nav.feedback': 'Feedback',
  'nav.games': 'Games',
  'nav.privacy': 'Privacy Policy',
  'nav.menu': 'Menu',
  'nav.scan': 'Scan QR Code',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.locations': 'Locations',

  'lang.ar': 'AR',
  'lang.en': 'EN',

  'filter.glutenFree': 'Gluten Free',
  'filter.lactoseFree': 'Lactose Free',
  'filter.vegetarian': 'Vegetarian',
  'filter.spicy': 'Spicy',
  'filter.sugarFree': 'Sugar Free',
  'filter.vegan': 'Vegan',

  'hero.badge': 'Fresh \u2022 Local \u2022 Made with Love',
  'hero.title': 'BIOLA CAFE & RESTAURANT',
  'hero.subtitle': 'Artisan breakfast, wholesome bowls, handcrafted pastries, and irresistible desserts \u2014 all made fresh daily.',
  'hero.ctaMenu': 'Explore Menu',
  'hero.ctaAbout': 'Our Story',
  'hero.ctaContact': 'Contact Us',
  'hero.ctaLocation': 'Our Branches',

  'menu.title': 'Our Menu',
  'menu.subtitle': 'Explore our curated selection of handcrafted dishes, made with the freshest ingredients.',
  'menu.searchPlaceholder': 'Search Item By Name, Price Or Description.',
  'menu.noItems': 'No items found',
  'menu.noItemsHint': 'Try adjusting your search or category filter',
  'menu.allItems': 'All Items',
  'menu.currency': 'AED',
  'menu.detail': 'View details',
  'menu.popular': 'Popular',
  'menu.tapToClose': 'Tap outside to close',

  'view.grid': 'Grid',
  'view.list': 'List',

  'category.all': 'All',
  'category.hotDrinks': 'Hot Drinks',
  'category.coldDrinks': 'Cold Drinks',
  'category.sweets': 'Sweets',
  'category.food': 'Food',
  'category.breakfast': 'Breakfast',

  'menuGroup.hotDrinks': 'Hot Drinks',
  'menuGroup.coldDrinks': 'Cold Drinks',
  'menuGroup.sweets': 'Sweet Treats',
  'menuGroup.food': 'Savory Dishes',
  'menuGroup.breakfast': 'Breakfast',

  'item.1.name': 'Spanish Cortado',
  'item.1.desc': 'Espresso shot balanced with warm condensed milk for a rich, lightly sweet finish.',
  'item.2.name': 'Spanish Latte',
  'item.2.desc': 'Smooth espresso layered with steamed milk and condensed milk for a creamy, sweet coffee.',
  'item.3.name': 'Latte',
  'item.3.desc': 'Espresso topped with velvety steamed milk and a light layer of foam.',
  'item.4.name': 'Cappuccino',
  'item.4.desc': 'Equal parts espresso, steamed milk and airy foam for a classic balanced coffee.',
  'item.5.name': 'Cortado',
  'item.5.desc': 'Espresso cut with a small amount of warm milk for a strong yet smooth taste.',
  'item.6.name': 'V60',
  'item.6.desc': 'Hand-poured filter coffee, brewed slowly for a clean, aromatic cup.',
  'item.7.name': 'Piccolo',
  'item.7.desc': 'A mini latte \u2014 single espresso shot with steamed milk, served in a small cup.',
  'item.8.name': 'Espresso',
  'item.8.desc': 'A concentrated shot of rich, full-bodied coffee.',
  'item.9.name': 'Hot Chocolate',
  'item.9.desc': 'Warm, velvety melted chocolate served rich and comforting.',
  'item.10.name': 'Matcha Hot',
  'item.10.desc': 'Ceremonial-grade matcha whisked with steamed milk for an earthy, smooth warm drink.',
  'item.11.name': 'Americano',
  'item.11.desc': 'Espresso diluted with hot water for a lighter, smooth black coffee.',
  'item.12.name': 'Acai Smoothie',
  'item.12.desc': 'Blended acai berries with mixed fruits for a refreshing antioxidant-rich drink.',
  'item.13.name': 'Iced Pistachio',
  'item.13.desc': 'Chilled pistachio-flavored milk drink with a nutty, creamy finish.',
  'item.14.name': 'Passion Fruit Mojito',
  'item.14.desc': 'Fresh mint and lime muddled with sweet passion fruit and soda.',
  'item.15.name': 'Iced Spanish',
  'item.15.desc': 'Chilled espresso with condensed milk over ice for a sweet, cold coffee.',
  'item.16.name': 'Iced Matcha',
  'item.16.desc': 'Chilled matcha whisked with cold milk over ice.',
  'item.17.name': 'Strawberry Mojito',
  'item.17.desc': 'Fresh mint and lime with muddled strawberries and soda.',
  'item.18.name': 'Blue Berry Mojito',
  'item.18.desc': 'Fresh mint and lime with blueberries and soda, refreshingly tart.',
  'item.19.name': 'Lemon Mojito',
  'item.19.desc': 'Classic mint and lime mojito, crisp and citrusy.',
  'item.20.name': 'Milkshake',
  'item.20.desc': 'Thick, creamy blended milkshake.',
  'item.21.name': 'Hibiscus',
  'item.21.desc': 'Chilled hibiscus tea, tart and naturally refreshing.',
  'item.22.name': 'Pepsi',
  'item.22.desc': 'Classic chilled cola soft drink.',
  'item.23.name': 'Mountain Dew',
  'item.23.desc': 'Citrus-flavored carbonated soft drink.',
  'item.24.name': 'Cola',
  'item.24.desc': 'Classic chilled cola soft drink.',
  'item.25.name': 'Water',
  'item.25.desc': 'Chilled bottled water.',
  'item.26.name': 'Acai Bowl',
  'item.26.desc': 'Blended acai topped with granola, fresh fruit and honey.',
  'item.27.name': 'Chocolate Croissant',
  'item.27.desc': 'Buttery, flaky croissant filled with rich dark chocolate.',
  'item.28.name': 'Date Pudding',
  'item.28.desc': 'Warm sticky date sponge cake soaked in caramel sauce, topped with vanilla ice cream.',
  'item.29.name': 'Banana Pudding',
  'item.29.desc': 'Layers of creamy vanilla custard, banana and biscuit.',
  'item.30.name': 'Mixed Berry Mille-Feuille',
  'item.30.desc': 'Crisp puff pastry layered with pastry cream and fresh mixed berries.',
  'item.31.name': 'Molten Chocolate Cake',
  'item.31.desc': 'Warm chocolate cake with a gooey molten center, served with vanilla ice cream.',
  'item.32.name': 'San Sebastian Cheesecake',
  'item.32.desc': 'Basque-style burnt cheesecake, creamy inside with a caramelized top.',
  'item.33.name': 'Cheese Cake',
  'item.33.desc': 'Classic creamy baked cheesecake on a biscuit base.',
  'item.34.name': 'Cheesecake Trio-Choux',
  'item.34.desc': 'Choux pastry filled with cheesecake cream, a bite-sized indulgence.',
  'item.35.name': 'Bread Pudding',
  'item.35.desc': 'Warm baked bread pudding soaked in custard and spices.',
  'item.36.name': 'Kinder Cookies',
  'item.36.desc': 'Soft-baked cookies loaded with Kinder chocolate.',
  'item.37.name': 'Galaxy Cookies',
  'item.37.desc': 'Soft-baked cookies loaded with Galaxy chocolate.',
  'item.38.name': 'Alfredo Pasta',
  'item.38.desc': 'Pasta tossed in a creamy Alfredo sauce.',
  'item.39.name': 'Red Sauce Pasta',
  'item.39.desc': 'Pasta tossed in a rich tomato-based sauce.',
  'item.40.name': 'Burger Double',
  'item.40.desc': 'Two juicy grilled patties stacked with cheese and fresh toppings in a soft bun.',
  'item.41.name': 'Burger Single Chicken/Beef',
  'item.41.desc': 'Grilled chicken or beef patty with fresh toppings in a soft bun.',
  'item.42.name': 'Steak Chicken & Beef',
  'item.42.desc': 'Grilled strips of chicken and beef, seasoned and served together.',
  'item.43.name': 'Toast Chicken',
  'item.43.desc': 'Grilled chicken filling in toasted bread.',
  'item.44.name': 'Toast Beef',
  'item.44.desc': 'Grilled beef filling in toasted bread.',
  'item.45.name': 'BIOLA Signature Chicken',
  'item.45.desc': 'Our signature chicken sandwich with house special sauce.',
  'item.46.name': 'BIOLA Signature Beef',
  'item.46.desc': 'Our signature beef sandwich with house special sauce.',
  'item.47.name': 'Fries with Sauce & Chicken',
  'item.47.desc': 'Crispy fries topped with sauce and grilled chicken pieces.',
  'item.48.name': 'Fries with Sauce',
  'item.48.desc': 'Crispy fries topped with our house sauce.',
  'item.49.name': 'Fries (Plain)',
  'item.49.desc': 'Classic crispy golden fries.',
  'item.50.name': "Brioche Labnah Za'atar",
  'item.50.desc': "Toasted brioche bun topped with creamy labneh, za'atar and slow-roasted tomato.",
  'item.51.name': 'Croissant Egg Cheese',
  'item.51.desc': 'Flaky croissant filled with scrambled eggs and melted cheese.',
  'item.52.name': 'Shakshuka',
  'item.52.desc': 'Poached eggs in a rich tomato sauce, served with sesame bread.',
  'item.53.name': "Zatar Croissant",
  'item.53.desc': "Buttery croissant topped with za'atar and olive oil.",
  'item.54.name': 'Plain Croissant',
  'item.54.desc': 'Classic buttery, flaky croissant.',
  'item.55.name': 'Almond Croissant',
  'item.55.desc': 'Croissant filled with almond cream, topped with sliced almonds and powdered sugar.',
  'item.56.name': 'Avocado & Egg Toast',
  'item.56.desc': 'Toasted bread topped with mashed avocado and scrambled eggs, finished with pomegranate and feta.',
  'item.57.name': 'Granula Bowl',
  'item.57.desc': 'Crunchy granola with yogurt, fresh fruit and honey.',
  'item.58.name': 'Honey - Feta Croissant',
  'item.58.desc': 'Buttery croissant filled with feta cheese and drizzled with honey.',
  'item.59.name': 'Smoke Turkey Cheese Croissant',
  'item.59.desc': 'Croissant filled with smoked turkey and melted cheese.',
  'item.60.name': 'Three  Cheese Croissant',
  'item.60.desc': 'Buttery, flaky croissant filled with a warm blend of three melted cheeses for a rich, gooey bite.',
  'item.61.name': 'Strawberry Milkshake',
  'item.61.desc': 'A thick, creamy blend of fresh strawberries and cold milk, topped with whipped cream for a sweet, fruity treat.',
  

  'about.title': 'Crafted with Care',
  'about.desc': 'At BIOLA CAFE & RESTAURANT, we believe great food starts with great ingredients. Every dish is prepared fresh daily using locally sourced produce, artisan breads, and premium dairy. From our flaky pastries to our vibrant bowls, we pour passion into every plate.',
  'about.fresh.title': 'Fresh Ingredients',
  'about.fresh.desc': 'Locally sourced, seasonal produce picked at peak freshness.',
  'about.love.title': 'Made with Love',
  'about.love.desc': 'Every dish handcrafted by our passionate chefs.',
  'about.daily.title': 'Daily Fresh',
  'about.daily.desc': 'Baked and prepared fresh every single morning.',

  'home.aboutTitle': 'Crafted with Care',
  'home.aboutDesc': 'At BIOLA CAFE & RESTAURANT, we believe great food starts with great ingredients. Every dish is prepared fresh daily using locally sourced produce, artisan breads, and premium dairy. From our flaky pastries to our vibrant bowls, we pour passion into every plate.',
  'home.aboutCta': 'Learn More About Us',

  'menuTeaser.badge': 'Freshly Made Daily',
  'menuTeaser.title': 'A Taste of What Awaits',
  'menuTeaser.desc': 'From handcrafted specialty coffee and flaky pastries to vibrant bowls and indulgent desserts — explore our full menu of fresh, locally sourced dishes.',
  'menuTeaser.cta': 'Explore Full Menu',

  'about.heroBadge': 'Est. 2020 \u2014 Abu Dhabi, UAE',
  'about.heroTitle': 'About BIOLA',
  'about.heroSubtitle': 'A proudly homegrown cafe & restaurant dedicated to exceptional coffee, premium beverages, and memorable dining experiences.',

  'about.companyTitle': 'Company Introduction',
  'about.companyDesc': 'BIOLA is a proudly homegrown coffee shop company established in 2020 in Abu Dhabi, United Arab Emirates. Since our inception, we have been dedicated to providing exceptional coffee experiences, premium beverages, and a welcoming atmosphere for our customers. Over the years, our commitment to quality, consistency, and outstanding customer service has enabled us to expand successfully to three branches across Abu Dhabi.',

  'about.established': 'Established',
  'about.branches': 'Branches',
  'about.team': 'Team Members',
  'about.menuItems': 'Menu Items',

  'about.visionTitle': 'Our Vision',
  'about.visionDesc': 'To deliver exceptional coffee and memorable customer experiences by combining premium ingredients, skilled craftsmanship, and warm hospitality in every cup we serve. BIOLA aims to create memorable food and beverage experiences through premium ingredients, professional preparation methods, friendly service, doorstep service, and clean and safe operations.',

  'about.missionTitle': 'Our Mission',
  'about.missionDesc': "To become one of Abu Dhabi's most trusted and recognized coffee brands, known for quality, innovation, and community engagement \u2014 providing customers with high-quality food and beverages while maintaining strict standards of customer service excellence, food safety, and operational efficiency.",

  'about.commitmentsTitle': 'Our Standards',
  'about.commitmentsDesc': 'We are committed to maintaining high standards across every aspect of our operations.',

  'about.commit.foodSafety': 'Food Safety',
  'about.commit.foodSafetyDesc': 'Strict food safety protocols and regular inspections to ensure the highest standards.',
  'about.commit.hygiene': 'Hygiene & Sanitation',
  'about.commit.hygieneDesc': 'Rigorous cleaning and sanitation practices maintained throughout all operations.',
  'about.commit.quality': 'Product Quality',
  'about.commit.qualityDesc': 'Premium ingredients and careful preparation for consistently excellent results.',
  'about.commit.satisfaction': 'Customer Satisfaction',
  'about.commit.satisfactionDesc': 'Friendly, attentive service designed to exceed expectations every visit.',

  'about.servicesTitle': 'Our Services',
  'about.servicesDesc': 'Beyond dining \u2014 complete hospitality solutions for every occasion.',

  'about.service.corporate': 'Corporate Catering',
  'about.service.corporateDesc': 'Customized menus for meetings, conferences, and business events with professional presentation.',
  'about.service.private': 'Private Events',
  'about.service.privateDesc': 'Birthdays, anniversaries, and private celebrations with personalized setups.',
  'about.service.weddings': 'Weddings & Engagements',
  'about.service.weddingsDesc': 'Elegant setups and curated menus for your special day.',
  'about.service.social': 'Social Gatherings',
  'about.service.socialDesc': 'Perfect venue and dining experience for any get-together with friends and family.',
  'about.service.exhibitions': 'Exhibitions & Pop-ups',
  'about.service.exhibitionsDesc': 'Professional support for exhibitions, pop-ups, and brand activations with trained staff.',
  'about.service.delivery': 'Takeaway & Delivery',
  'about.service.deliveryDesc': 'Enjoy your favorite meals wherever you are with our convenient takeaway and delivery service.',

  'about.sustainTitle': 'Sustainability',
  'about.sustainDesc': 'At BIOLA, we are committed to sustainable practices that protect our environment and support our community. Small actions today build a better tomorrow for everyone.',
  'about.sustain.sourcing': 'Sustainable Sourcing',
  'about.sustain.sourcingDesc': 'We source local and seasonal ingredients to support local farmers and reduce our carbon footprint.',
  'about.sustain.eco': 'Eco-Friendly Practices',
  'about.sustain.ecoDesc': 'We minimize waste, recycle responsibly, and use eco-friendly packaging whenever possible.',
  'about.sustain.community': 'Community Support',
  'about.sustain.communityDesc': 'We believe in giving back by supporting local communities and meaningful initiatives.',

  'about.ctaTitle': 'Ready to Experience BIOLA?',
  'about.ctaDesc': 'Visit one of our three branches across Abu Dhabi or get in touch for catering and events.',
  'about.ctaButton': 'Get In Touch',

  'contact.pageTitle': 'Get In Touch',
  'contact.pageSubtitle': 'Have a question, feedback, or need catering? We would love to hear from you.',
  'contact.phone': 'Phone',
  'contact.email': 'Email',
  'contact.person': 'Contact Person',
  'contact.address': 'Address',
  'contact.visitTitle': 'Visit Us',
  'contact.visitDesc': 'Find us at one of our three locations across Abu Dhabi.',
  'contact.hours': 'Opening Hours',
  'contact.hoursValue': 'Mon-Sun: 9:00 AM - 9:00 PM',

  'contact.formTitle': 'Send a Message',
  'contact.formDesc': 'Fill out the form below and we will get back to you as soon as possible.',
  'contact.form.name': 'Full Name',
  'contact.form.namePlaceholder': 'Enter your full name',
  'contact.form.email': 'Email Address',
  'contact.form.emailPlaceholder': 'Enter your email address',
  'contact.form.subject': 'Subject',
  'contact.form.subjectPlaceholder': 'What is this about?',
  'contact.form.message': 'Message',
  'contact.form.messagePlaceholder': 'Tell us how we can help...',
  'contact.form.maxChars': 'Maximum 500 characters',
  'contact.form.send': 'Send Message',
  'contact.form.sent': 'Message Sent',
  'contact.form.success': 'Thank you! Your message has been sent successfully.',
  'contact.form.error': 'Something went wrong. Please try again.',
  'contact.form.spamError': 'Unable to send message. Please try again later.',

  'privacy.pageTitle': 'Privacy Policy',
  'privacy.pageSubtitle': 'How we collect, use, and protect your personal information.',
  'privacy.effective': 'Effective Date:',
  'privacy.effectiveDate': 'January 1, 2024',
  'privacy.footer': '\u00A9 {year} BIOLA CAFE & RESTAURANT. All rights reserved.',

  'privacy.introTitle': 'Introduction',
  'privacy.introContent': 'BIOLA CAFE & RESTAURANT ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. Please read this policy carefully to understand our practices regarding your personal data.',

  'privacy.infoTitle': 'Information We Collect',
  'privacy.infoContent': 'We may collect personal information that you voluntarily provide to us, including but not limited to your name, email address, phone number, and any messages you send through our contact form. We also collect non-personal information such as browser type, device information, and usage data to improve our website experience.',

  'privacy.useTitle': 'How We Use Your Information',
  'privacy.useContent': 'We use the information we collect to respond to your inquiries, process your requests, improve our services, communicate with you about promotions and updates, and ensure the security of our website. We do not sell, rent, or trade your personal information to third parties for marketing purposes.',

  'privacy.sharingTitle': 'Information Sharing and Disclosure',
  'privacy.sharingContent': 'We may share your information with trusted service providers who assist us in operating our website and conducting our business, provided they agree to keep this information confidential. We may also disclose information when required by law or to protect our rights, property, or safety.',

  'privacy.securityTitle': 'Data Security',
  'privacy.securityContent': 'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.',

  'privacy.cookiesTitle': 'Cookies and Tracking Technologies',
  'privacy.cookiesContent': 'Our website may use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand where our visitors come from. You can choose to disable cookies through your browser settings, though this may affect certain features of our website.',

  'privacy.rightsTitle': 'Your Rights',
  'privacy.rightsContent': 'You have the right to access, correct, update, or delete your personal information. You may also object to the processing of your personal data or request that we restrict its use. To exercise these rights, please contact us using the information provided on our Contact page.',

  'privacy.changesTitle': 'Changes to This Policy',
  'privacy.changesContent': 'We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this policy periodically for any updates. Your continued use of our website after any changes constitutes acceptance of the revised policy.',

  'privacy.contactTitle': 'Contact Us',
  'privacy.contactContent': 'If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at biola.ae1@gmail.com or call us at +971 50 446 4660. We are committed to addressing your privacy concerns promptly and transparently.',

  'locations.title': 'Visit Us',
  'locations.subtitle': 'Come experience the warm atmosphere and delicious flavors at our cozy cafe location.',
  'locations.name': 'BIOLA CAFE & RESTAURANT',
  'locations.address': 'Al Muroor Road, Near Al Wahda Mall, Abu Dhabi, UAE',
  'locations.hours': 'Mon-Sun: 9:00 AM - 9:00 PM',

  'locations.pageBadge': 'Three Branches \u2022 Abu Dhabi',
  'locations.pageTitle': 'Our Locations',
  'locations.pageSubtitle': 'Discover our three branches across Abu Dhabi and find the one closest to you.',
  'locations.hoursLabel': 'Opening Hours',
  'locations.getDirections': 'Get Directions',
  'locations.ctaTitle': 'Find Your Nearest Branch',
  'locations.ctaDesc': 'Tap Get Directions to open the exact location in Google Maps and start your journey to great coffee.',
  'locations.ctaButton': 'Open Google Maps',
  'locations.branch.1.tag': 'Branch 01',
  'locations.branch.1.name': 'Biola Cafe (Mafraq)',
  'locations.branch.1.address': 'ADNOC Service Station | Mafraq (171), Bani Yas, Baniyas East, Abu Dhabi',
  'locations.branch.1.hours': 'Mon-Sun: 9:00 AM - 9:00 PM',
  'locations.branch.2.tag': 'Branch 02',
  'locations.branch.2.name': 'Auto Cafe (Baniyas)',
  'locations.branch.2.address': 'ADNOC Service Station -114, Al Burouj St, Bani Yas, Baniyas East, Abu Dhabi',
  'locations.branch.2.hours': 'Mon-Sun: 9:00 AM - 9:00 PM',
  'locations.branch.3.tag': 'Branch 03',
  'locations.branch.3.name': 'Auto Cafe (Khalifa)',
  'locations.branch.3.address': 'ADNOC Service Station -523 Aldaar, Khalifa City, SE45, Abu Dhabi',
  'locations.branch.3.hours': 'Mon-Sun: 9:00 AM - 9:00 PM',

  'contact.title': 'Have Questions?',
  'contact.desc': 'Reach out to us for reservations, catering, or just to say hello. We would love to hear from you!',

  'footer.rights': '\u00A9 {year} BIOLA CAFE & RESTAURANT. All rights reserved. Fresh food, warm vibes.',

  'filter.applyFilters': 'Apply filters',
  'sidebar.filters': 'Filters',

  'scan.title': 'Scan QR Code',
  'scan.subtitle': 'Use your camera to scan any QR code and instantly view links, specials, or digital menus.',
  'scan.qrDesc': 'Scan this QR code with your phone camera to view our digital menu and order directly.',
  'scan.qrHint': 'Point your phone camera at the code above and tap the notification that appears to open our menu instantly.',
  'scan.visitSite': 'Visit Our Menu',
  'scan.scannerTitle': 'Camera Scanner',
  'scan.start': 'Start Scanning',
  'scan.stop': 'Stop Scanning',
  'scan.ready': 'Camera ready',
  'scan.readyHint': 'Press Start Scanning and point your camera at a QR code.',
  'scan.status.idle': 'Idle',
  'scan.status.starting': 'Starting',
  'scan.status.scanning': 'Scanning',
  'scan.status.stopped': 'Stopped',
  'scan.status.error': 'Error',
  'scan.resultTitle': 'Scan Result',
  'scan.detected': 'Detected Content',
  'scan.openLink': 'Open Link',
  'scan.clear': 'Clear',
  'scan.emptyResult': 'No result yet',
  'scan.emptyHint': 'Point the camera at a QR code and the decoded content will appear here.',
  'scan.howBadge': 'How It Works',
  'scan.howTitle': 'Scanning in Three Simple Steps',
  'scan.step1.title': 'Allow Camera',
  'scan.step1.desc': 'Grant camera access when your browser asks for permission.',
  'scan.step2.title': 'Align the Code',
  'scan.step2.desc': 'Position the QR code inside the frame for a clear, sharp view.',
  'scan.step3.title': 'Get the Result',
  'scan.step3.desc': 'The decoded link or text appears instantly in the result panel.',

};